import { render, staticRenderFns } from "./product-bundle-form.vue?vue&type=template&id=564b0458&"
import script from "./product-bundle-form.vue?vue&type=script&lang=js&"
export * from "./product-bundle-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports